export enum ButtonTypes {
    None = 0,
    Negative = 1,
    Positive = 2
}